// @flow

import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import debounce from 'lodash/debounce';
import Header from '~/src/components/Header';
import DynamicUrl from './components/DynamicUrl';
import Footer from '~/src/components/Footer';

type Props = {
  dynamicUrlConfig: Object,
  dynamicUrlCode: string,
  setWaterMarkAsset: Function,
  setProductColor: Function,
  dynamicUrlTransformations: Object,
  setWaterMarkText: Function
}

@inject((stores: Object) => {
  const {
    dynamicUrlConfig,
    dynamicUrlCode,
    setWaterMarkAsset,
    setProductColor,
    dynamicUrlTransformations,
    setWaterMarkText,
  } = stores.homeStore;
  return {
    dynamicUrlConfig,
    dynamicUrlCode,
    setWaterMarkAsset,
    setProductColor,
    dynamicUrlTransformations,
    setWaterMarkText,
  };
})

@observer
class TransformsPage extends Component<Props> {
  render() {
    const color = this.props.dynamicUrlConfig.transformation.transformation[0].effect.split(':')[1];
    const text = this.props.dynamicUrlTransformations.waterMarkText;
    return (
      <div className="container">
        <Header/>
        <DynamicUrl
          config={this.props.dynamicUrlConfig}
          code={this.props.dynamicUrlCode}
          setWaterMarkAsset={this.props.setWaterMarkAsset}
          setColor={this.props.setProductColor}
          waterMarkAsset={this.props.dynamicUrlTransformations.waterMarkAsset}
          color={`#${color}`}
          text={text}
          setText={debounce(this.props.setWaterMarkText, 1000)}
        />
        <Footer/>
      </div>
    );
  }
}

export default TransformsPage;
